module.exports = __webpack_public_path__ + "img/gloves_001.4347c450.png";